import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chevron-double-left",
  "use": "icon-chevron-double-left-usage",
  "viewBox": "0 0 18.001 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18.001 12\" id=\"icon-chevron-double-left\">\r\n  <path d=\"M-1985-7239l5.938-6,2.062,2-4,4,4,4-2.062,2Zm-10,0,5.94-6,2.06,2-4,4,4,4-2.06,2Z\" transform=\"translate(1995.001 7245)\" fill=\"currentColor\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol